import { Mark, Subject } from '@/plugins/api'
import alert from '@/plugins/alert'
import { get, keyBy, orderBy, max } from 'lodash'
import constant from '@/store/other/constant'

export default {
  namespaced: true,
  state: {
    marks: [],
    student: [],
    semester: {},
    semestersData: [],
    subjects: [],
    factors: [],
    studentMarks: [],
    subjectMarks: []
  },
  actions: {
    async fetchStudentMarks({ commit, state }, options) {
      try {
        // Get subject list
        const subjectParams = {
          division: get(options.class, 'division'),
          grade: get(options, 'grade.id'),
          _sort: 'subjectGroupIndex:asc',
          type: 'coreCurriculum'
        }
        const subjects = await Subject.fetch(subjectParams)

        // Get all marks
        const semesterList = get(options, 'semesters', null)
        const markParams = {
          class: get(options, 'class.id'),
          student: get(options, 'student.id'),
          semester_in: semesterList ? semesterList.map(s => s.id) : []
        }
        const marks = await Mark.fetch(markParams)

        const semestersData = semesterList.map(semester => {
          const semesterData = { ...semester }

          // Get all marks by semester
          const semesterMarks = marks.filter(m => m.semester.id === semester.id)

          // Lấy số cột điểm tối đa trên 1 factor
          const factors = keyBy(constant.defaultFactors, 'type')
          Object.values(factors).reduce((acc, factor) => {
            const factorMarks = subjects.reduce((acc, subject) => {
              const markNo = semesterMarks.filter(
                m => m.factor.type === factor.type && get(m.subject, 'id') === subject.id
              ).length
              return [...acc, markNo]
            }, [])
            factors[factor.type] = {
              ...factors[factor.type],
              maxColumn: max(factorMarks) > factor.quantity ? max(factorMarks) : factor.quantity
            }
          }, [])
          semesterData.factors = Object.values(factors)
          semesterData.maxFactor = Object.values(factors).reduce((count, factor) => {
            count += factor.maxColumn
            return count
          }, 0)

          // tạo điểm từng môn
          const subjectMarks = subjects.reduce((acc, subject) => {
            const SMs = Object.values(factors).reduce((acc, factor) => {
              // tìm điểm theo factor và môn
              const markObject = semesterMarks.filter(
                m => m.factor.type === factor.type && get(m.subject, 'id') === subject.id
              )
              let markByFactor = Array.from(Array(factor.maxColumn).keys()).map(index => markObject[index] || {})
              markByFactor = orderBy(markByFactor, ['date'], ['asc'])
              return [...acc, ...markByFactor]
            }, [])
            return [...acc, { subject, marks: SMs }]
          }, [])
          semesterData.subjectMarks = subjectMarks

          return semesterData
        })
        commit('changeState', {
          subjects,
          semestersData,
          student: options.student
        })
      } catch (error) {
        alert.error(error)
        console.error(error)
      }
    },
    async fetchMarks({ commit }, options) {
      try {
        commit('setMarks', await Mark.fetch(options))
      } catch (error) {
        alert.error(error)
      }
    },
    setStudent({ commit }, student) {
      commit('setStudent', student)
    },
    setSemester({ commit }, semester) {
      commit('setSemester', semester)
    },
    setSubjects({ commit }, subjects) {
      commit('setSubjects', subjects)
    },
    setFactors({ commit }, factors) {
      commit('setFactors', factors)
    }
  },
  mutations: {
    setMarks(state, marks) {
      state.marks = marks
    },
    setStudent(state, student) {
      state.student = student
    },
    setSemester(state, semester) {
      state.semester = semester
    },
    setSubjects(state, subjects) {
      state.subjects = subjects
    },
    setFactors(state, factors) {
      state.factors = factors
    }
  },
  getters: {
    // marks: state => {
    //   // return state.subjects.reduce((acc, subject) => {
    //   //   const marks = subject.factors
    //   //     .filter(f => f.semesterType === state.semester.type) // Lọc cho đúng học kỳ
    //   //     .sort((a, b) => a.index - b.index) // sắp xếp các cột đúng thứ tự. (miệng - 15 phút -....)
    //   //     .reduce((acc, factor) => {
    //   //       const markObject = state.marks
    //   //         .filter(m => m.factor.id === factor.id) // tìm điểm theo factor tương ứng
    //   //         .reduce((acc, mark) => ({ ...acc, [mark.data.index]: mark }), {}) // đánh dấu diểm theo index
    //   //       const markByFactor = Array.from(Array(factor.quantity).keys()).map(index => markObject[index] || {}) // khớp điểm
    //   //       return [...acc, ...markByFactor]
    //   //     }, []) // build factor schema
    //   //   return [...acc, { subject: subject, marks }]
    //   // }, [])

    //   return state.subjects.reduce((acc, subject) => {
    //     const marks = state.factors
    //       .sort((a, b) => a.index - b.index) // sắp xếp các cột đúng thứ tự. (miệng - 15 phút -....)
    //       .reduce((acc, factor) => {
    //         const markObject = state.marks
    //           .filter(
    //             m => m.factor.type === factor.type && m.subject.id === subject.id && m.semester.id === state.semester.id
    //           ) // tìm điểm theo điều kiện tương ứng
    //           .reduce((acc, mark) => ({ ...acc, [mark.data.index]: mark }), {}) // đánh dấu diểm theo index
    //         const markByFactor = Array.from(Array(factor.quantity).keys()).map(index => markObject[index] || {}) // khớp điểm
    //         return [...acc, ...markByFactor]
    //       }, []) // build factor schema
    //     return [...acc, { subject: subject, marks }]
    //   }, [])
    // },
    students: state => {
      return state.students
    },
    semester: state => {
      return state.semester
    }
  }
}
